import React from 'react';

type LazyComponent = () => Promise<{ default: React.ComponentType }>;
type ComponentMap = Record<string, LazyComponent | 'redirect-404'>;

export const pagesMap: ComponentMap = {
  DashboardPage: () => import('@/feature/dashboard/pages/DashboardPage'),
  Profile: () => import('@/feature/profile/pages/Profile'),
  MyDrivePage: () => import('@/feature/files/pages/MyDrivePage'),
  PublicOrderViewPage: () =>
    import('@/feature/service-business/pages/PublicOrderStatusPage'),
  ServiceBusinessPublicPage: () =>
    import('@/feature/service-business/pages/ServiceBusinessPublicPage'),
  ServiceBusinessBackofficePage: () =>
    import('@/feature/service-business/pages/ServiceBusinessBackofficePage'),
  CustomerPortalPage: () =>
    import('@/feature/service-business/pages/CustomerPortalPage'),
  WebsiteBuilderAdminPage: () =>
    import('@/feature/website-builder/pages/WebsiteBuilderAdminPage'),
  WebsiteBuilderEditorPage: () =>
    import('@/feature/website-builder/pages/WebsiteBuilderEditorPage'),
  WebsiteBuilderMenusPage: () =>
    import('@/feature/website-builder/pages/WebsiteBuilderMenusPage'),
  WebsiteBuilderFormsPage: () =>
    import('@/feature/website-builder/pages/WebsiteBuilderFormsPage'),
  WebsiteBuilderPagesEntryPage: () =>
    import('@/feature/website-builder/pages/WebsiteBuilderPagesEntryPage'),
  WebsiteBuilderPreviewEntryPage: () =>
    import('@/feature/website-builder/pages/WebsiteBuilderPreviewEntryPage'),
  WebsiteBuilderPreviewPage: () =>
    import('@/feature/website-builder/pages/WebsiteBuilderPreviewPage'),
  PublicWebsitePage: () =>
    import('@/feature/website-builder/pages/PublicWebsitePage'),
  LegacyWebsitePageRedirect: () =>
    import('@/feature/website-builder/pages/LegacyWebsitePageRedirect'),

  SignInPage: () => import('@/feature/auth/pages/SignIn'),
  CreateAccountPage: () => import('@/feature/auth/pages/CreateAccount'),
  ActivateAccountPage: () => import('@/feature/auth/pages/ActivateAccount'),
  CompanyOwnerOnboardingPage: () =>
    import('@/feature/auth/pages/CompanyOnboarding'),
  SetPasswordPage: () => import('@/feature/auth/pages/SetPassword'),
  TermsPage: () => import('./legal/TermsPage'),
  PrivacyPage: () => import('./legal/PrivacyPage'),
  CookiesPage: () => import('./legal/CookiesPage'),

  NotFound: () => import('./not-found'),
  LandingPage: () => import('./landing'),

  AdminOverview: () =>
    import('@/feature/admin/overview/pages/AdminOverviewPage'),
  AdminTenantSettings: () =>
    import('@/feature/admin/tenants/pages/TenantSettingsPage'),
  AdminCompanyDetails: () =>
    import('@/feature/admin/tenants/pages/CompanyDetailsPage'),
  AdminCompanyUserProfile: () =>
    import('@/feature/admin/tenants/pages/CompanyUserProfilePage'),
  AdminTenantPackages: () =>
    import('@/feature/admin/tenants/pages/TenantPackagesPage'),
  AdminTenantPackageDetails: () =>
    import('@/feature/admin/tenants/pages/TenantPackageDetailsPage'),
  AdminCompanyOnboarding: () =>
    import('@/feature/admin/tenants/pages/CompanyOnboardingPage'),
  AdminWebsiteTemplates: () =>
    import('@/feature/admin/website-templates/pages/AdminWebsiteTemplatesPage'),
  AdminSmsDashboard: () =>
    import('@/feature/admin/sms/pages/AdminSmsDashboardPage'),
  AdminHangfire: () =>
    import('@/feature/admin/hangfire/pages/AdminHangfirePage'),
  AdminHelpdesk: () => import('@/feature/helpdesk/pages/AdminHelpdeskPage'),
  AdminRolePermissions: () =>
    import('@/feature/admin/roles/pages/RolePermissionsPage'),
  AdminUserLogs: () => import('@/feature/admin/user-logs/pages/UserLogsPage'),
  AdminRoutesHelper: () =>
    import('@/feature/admin/routes/pages/AdminRoutesHelperPage'),

  Redirect404: 'redirect-404'
};
